import styled from '@emotion/styled';
import { RewardWalletIcon } from 'src/assets/icons/RewardWallet';
import { withConfig } from 'src/utils/withConfig';

export const FreeBetContainer = styled.div`
    width: 100%;
    font-size: 10px;
    font-weight: 600;
    cursor: pointer;
    position: relative;
`;

export const FreeBetButton = withConfig(theme => styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    height: 21px;
    background-color: ${theme.buttons.bgColor};
    color: ${theme.buttons.txtColor};
    text-align: center;
    padding: 4px;
    font-size: 10px;
`);

export const FreeBetLabel = styled.div`
    font-size: 12px;
    line-height: 1.2;
    color: #000;
    display: flex;
    align-items: center;
`;

export const FreeBetExpire = styled.div`
    font-size: 10px;
    line-height: normal;
    color: #767676;
`;

export const FreeBetDropdown = styled.div`
    position: absolute;
    z-index: 10;
    top: 100%;
    left: 0;
    width: 100%;
    background-color: white;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    margin-top: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    max-height: 200px;
    overflow-y: auto;
`;

export const FreeBetItem = styled.div`
    display: flex;
    flex-direction: row;
    line-height: normal;
    padding: 8px;
    align-items: flex-start;
    gap: 8px;

    input {
        margin: 0;
    }
`;

export const FreeBetItemContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const FreeBetItemLabel = styled.div`
    font-size: 12px;
    color: #141922;
    font-weight: 500;
`;

export const FreeBetItemExpire = styled.div`
    font-size: 10px;
    font-weight: 400;
    color: #141922;
`;

export const FreeBetAppliedContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: center;
    justify-content: center;
    padding: 4px;
`;

export const FreeBetAppliedLabel = styled.div`
    text-align: center;
    color: #4c7bd9;
    font-size: 12px;
    font-weight: 500;
`;


export const AppliedFreeBetContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    height: 21px;
`;

export const AppliedFreeBetBar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 3px;
    background-color: #393;
    color: white;
    padding: 4px;
`;

export const AppliedFreeBetLabel = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
`;

export const AppliedFreeBetAmount = styled.div`
    font-size: 10px;
    font-weight: 600;
    line-height: normal;
`;


export const CloseButton = styled.button`
    background: none;
    border: none;
    color: white;
    font-size: 12px;
    line-height: 1;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 12px;
    height: 12px;
`;

export const BonusIcon = styled(RewardWalletIcon, { label: 'BonusIcon' })`
    fill: white;
    width: 12px;
`;

export const SmallBonusButton = withConfig(theme => styled.button`
    background: ${theme.buttons.bgColor};
    width: 28px;
    height: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
    border: none;
`);
